
import { defineComponent } from 'vue'
import DottedInlineList from '@/components/DottedInlineList.vue'
import TrelloLogo from '@/components/TrelloLogo.vue'
import AuthCard from '@/components/AuthCard.vue'
import SignupForm from '@/components/SignupForm.vue'
import AtlassianFooter from '@/components/AtlassianFooter.vue'
import GlobalFooter from '@/components/GlobalFooter.vue'

export default defineComponent({
  components: {
    DottedInlineList,
    AuthCard,
    SignupForm,
    TrelloLogo,
    AtlassianFooter,
    GlobalFooter
  },
  data () {
    return {}
  }
})
